<div class="modal-header">
  <h3 class="modal-title">Section174 Adjustments</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div [hidden]="minimise" style="margin: 12px;">
  <b>Key:</b>
  <div class="badge btn-info">LEID - CDR - RPT.PD - BSLA - CUR - LOCAL ACCT - LOCAL ACCT DESC</div>

  @for (entity of section174List; track $index; let i = $index) {
<div style="margin: 10px;">
    <div style="margin: 10px;" class="entitie-holder">
      <button style="margin-left: 15px;" type="button" class="btn btn-xs btn-default"
              [title]="entity.SCHDM_DESC">
        {{ entity.LEID }} - {{ entity.CDR_NO }} - {{ entity.REPORTING_PERIOD }} - {{ entity.ME }} - {{ entity.CURR }}
        - {{ entity.LOCAL_ACCT }} - {{ entity.LOCAL_ACCT_DESC }}
      </button>
    </div>

    <div style="margin-top: 10px; margin-bottom: 15px; margin-left: 10px; margin-right: 10px; display: flex; gap: 15px;">
      <div style="flex: 0 0 25%;">
        <label for="book">Book</label>
        <div class="input-group">
          <span class="input-group-addon">USD</span>
          <input style="text-align: right" class="form-control" [ngModel]="entity.Book" readonly>
        </div>
      </div>
      <div style="flex: 0 0 25%;">
        <label for="book">Section 174 Book</label>
        <div class="input-group">
          <span class="input-group-addon">USD</span>
          <input style="text-align: right" class="form-control" [(ngModel)]="entity.Section_174_Book">
          <span class="input-group-addon">
            <button type="button" style="border: none; padding: 0; background: none;"
                    (click)="applysection174book(i)">Apply</button>
          </span>
        </div>
      </div>
    </div>
  </div>
}
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="reset-button" type="button" (click)="reset()">Reset</button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
